export const GIT_COMMIT = '3720c288eac49cd60dbb47fc9578825923642243'
